import { Client } from "@core/Client";
import { Language, Messages } from "../GUI/Language";
import { Constants } from "@core/Utils/Constants";
import { setTextFontScaledToBox } from "@core/Utils/HelperFunction";
import { effectsVolume } from "../Utils/Constants";
import { Phase } from "@core/Logic/Logic";

export class BalanceDisplay extends Phaser.GameObjects.Container {
    public historyView: boolean = false;

    protected graphics: Phaser.GameObjects.Graphics;
    protected hitArea: Phaser.Geom.Rectangle;

    protected creditDescriptionTextIfMoney: string = "";
    protected creditDescriptionTextIfCredit: string = Language.Get(Messages.CREDIT) + ":";

    protected longestText: string;
    protected playerName: Phaser.GameObjects.Text;
    protected denominationValue: Phaser.GameObjects.Text;
    protected creditsDescription: Phaser.GameObjects.Text;
    protected creditsValue: Phaser.GameObjects.Text;
    protected betDescription: Phaser.GameObjects.Text;
    protected betValue: Phaser.GameObjects.Text;
    protected winDescription: Phaser.GameObjects.Text;
    protected winValue: Phaser.GameObjects.Text;

    protected jackpotWin: Phaser.GameObjects.Text;

    protected creditsImage: Phaser.GameObjects.Image;
    protected betImage: Phaser.GameObjects.Image;
    protected winImage: Phaser.GameObjects.Image;

    protected targetBalance: number = 0;
    protected startingBalance: number = 0;
    protected animationTimeLeft: number;

    constructor(public scene, protected playerAndDenomText: boolean = true) {
        super(scene);
        this.createElements(scene);
    }

    protected createElements(scene) {
        this.graphics = new Phaser.GameObjects.Graphics(scene);
        this.add(this.graphics);

        if (this.playerAndDenomText) {
            let username = "";
            if (!Client.logic.setup.USER.ShowUsername || Client.logic.setup.ProviderType != 3)//provider 3 = imaxa gaming
                username = Client.logic.setup.USER.Name;
            else
                username = Client.logic.setup.USER.Name + " " + Client.logic.setup.USER.Nickname;

            this.playerName = new Phaser.GameObjects.Text(scene, 0, 0, username, Constants.PANEL.MISC_FONT);
            this.playerName.setOrigin(1, 0);
            this.add(this.playerName);

            this.denominationValue = new Phaser.GameObjects.Text(scene, 0, 0, Language.Get(Messages.ONE_CREDIT) + " = " + Language.InternationalNumberFormat.format(Client.logic.BalanceManager.GetDenomination()), Constants.PANEL.MISC_FONT);
            this.denominationValue.setOrigin(1, 0);
            this.add(this.denominationValue);
        }

        this.creditsDescription = new Phaser.GameObjects.Text(scene, 0, 0, this.creditDescriptionTextIfCredit, Constants.PANEL.CREDITS_FONT);
        this.creditsDescription.setOrigin(1, 0);
        this.add(this.creditsDescription);

        this.creditsValue = new Phaser.GameObjects.Text(scene, 0, 0, "12.345.678,90 €", Constants.PANEL.CREDITS_FONT);
        this.creditsValue.setOrigin(1, 0);
        this.add(this.creditsValue);

        this.betDescription = new Phaser.GameObjects.Text(scene, 0, 0, Language.Get(Messages.BET) + ":", Constants.PANEL.CREDITS_FONT);
        this.betDescription.setOrigin(1, 0);
        this.add(this.betDescription);

        this.betValue = new Phaser.GameObjects.Text(scene, 0, 0, "0,00 €", Constants.PANEL.CREDITS_FONT);
        this.betValue.setOrigin(1, 0);
        this.add(this.betValue);

        this.winDescription = new Phaser.GameObjects.Text(scene, 0, 0, Language.Get(Messages.WIN) + ":", Constants.PANEL.CREDITS_FONT);
        this.winDescription.setOrigin(1, 0);
        this.add(this.winDescription);

        //In IMAXA roulette, win acts as last win, and changes its text to "win" when in history mode. Other flavours have split win & lastwin values
        this.winValue = new Phaser.GameObjects.Text(scene, 0, 0, "0,00 €", Constants.PANEL.CREDITS_FONT);
        this.winValue.setOrigin(1, 0);
        this.add(this.winValue);

        this.jackpotWin = new Phaser.GameObjects.Text(scene, 0, 0, "Jackpot " + Language.Get(Messages.WIN) + " : 0.00€", Constants.PANEL.CREDITS_FONT);
        this.jackpotWin.setOrigin(1, 0);
        this.add(this.jackpotWin);

        this.DrawIcons();

        this.longestText = [Language.Get(Messages.CREDIT) + ":" + "100.000.000,00 €   ", Language.Get(Messages.BET) + ":" + "100.000.000,00 €   ", Language.Get(Messages.WIN) + ":" + "100.000.000,00 €   "].sort(
            function (a, b) {
                return b.length - a.length;
            }
        )[0];

        this.startingBalance = Client.logic.Credits;
        this.targetBalance = Client.logic.Credits;
        this.SetCreditsText(Client.logic.Credits);

        this.hitArea = new Phaser.Geom.Rectangle(0, 0, 10, 10);
        this.setInteractive(this.hitArea, Phaser.Geom.Rectangle.Contains);
        this.on('pointerup', (p, x, y, e) => {
            e.stopPropagation();
            if (Client.logic.currentGameState.phase != Phase.SHOWING_HISTORY_REPLAY) {
                Client.game.events.emit(Constants.EVENTS.TOGGLE_SHOW_MONEY, !Client.logic.showMoney);
                this.SetCreditsText(Client.logic.Credits);
                scene.sound.play(Constants.SOUNDS.FINANCIALS_CLICK, { volume: 0.25 * effectsVolume });
            }
        }, this);
    }

    public DrawIcons(): void {
        this.creditsImage = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET_WINS, "creditsIcon.png");
        this.creditsImage.setOrigin(0, 0);
        this.add(this.creditsImage);

        this.betImage = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET_WINS, "betIcon.png");
        this.betImage.setOrigin(0, 0);
        this.add(this.betImage);

        this.winImage = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET_WINS, "winIcon.png");
        this.winImage.setOrigin(0, 0);
        this.add(this.winImage);
    }

    public SetCreditsText(number: number) {
        if (Client.logic.showMoney) {
            this.creditsDescription.text = this.creditDescriptionTextIfMoney;
            this.creditsValue.text = Language.InternationalNumberFormat.format(Client.logic.BalanceManager.CreditToMoney(number));
        } else {
            this.creditsDescription.text = this.creditDescriptionTextIfCredit;
            this.creditsValue.text = number.toString();
        }
    }

    public SetBetText(number: number) {
        if (Client.logic.showMoney) {
            this.betValue.text = Language.InternationalNumberFormat.format(Client.logic.BalanceManager.CreditToMoney(number));
        } else {
            this.betValue.text = number.toString();
        }
    }

    public SetWinText(number: number, jackpotWin: number = 0) {
        if (Client.logic.showMoney) {
            this.winValue.text = Language.InternationalNumberFormat.format(Client.logic.BalanceManager.CreditToMoney(number));
        } else {
            this.winValue.text = number.toString();
        }

        if (jackpotWin > 0 && Client.logic.historyShown) {
            this.jackpotWin.text = "+ Jackpot " + Language.Get(Messages.HISTORY_WIN) + " : ";
            this.jackpotWin.text += Client.logic.showMoney ? Language.InternationalNumberFormat.format(Client.logic.BalanceManager.CreditToMoney(jackpotWin)) : Math.round(jackpotWin).toString();
            this.jackpotWin.visible = true;
        } else {
            this.jackpotWin.visible = false;
        }
    }

    public UpdateBalance(effects: boolean): void {
        if (effects) {
            this.targetBalance = Client.logic.Credits
            this.animationTimeLeft = Constants.PANEL.ANIMATION_TIME
        }
        else {
            console.log("Credits : " + Client.logic.Credits);
            this.targetBalance = this.startingBalance = Client.logic.Credits;
            this.SetCreditsText(Client.logic.Credits);
        }
    }

    public Update(time: number): void {
        if (this.targetBalance != this.startingBalance) {
            if (this.targetBalance < this.startingBalance)
                this.creditsValue.setColor(Constants.PANEL.TEXT_COLOR.LOST);
            else
                this.creditsValue.setColor(Constants.PANEL.TEXT_COLOR.WIN);

            this.animationTimeLeft = Math.max(this.animationTimeLeft - time / 1000, 0);
            this.SetCreditsText(Math.round(this.startingBalance + (this.targetBalance - this.startingBalance) * (1 - this.animationTimeLeft / Constants.PANEL.ANIMATION_TIME)));
            if (this.animationTimeLeft == 0) {
                this.startingBalance = this.targetBalance;
                // Safety measures
                this.SetCreditsText(Client.logic.Credits);
                this.creditsValue.setColor(Constants.PANEL.TEXT_COLOR.NORMAL);
            }
        } else if (this.creditsValue.style.color != Constants.PANEL.TEXT_COLOR.NORMAL) {
            this.creditsValue.setColor(Constants.PANEL.TEXT_COLOR.NORMAL);
        }
    }

    public HistoricMode(visible: boolean): void {
        this.historyView = visible;
        this.UpdatePosition(this.width, this.height);
    }

    public UpdatePosition(width, height): void {
        this.width = width;
        this.height = height;

        let verticalPadding = height / 50;
        let horizontalPadding = width / 50;

        this.graphics.clear();

        if (this.historyView)
            this.winDescription.text = Language.Get(Messages.HISTORY_WIN) + ":";
        else
            this.winDescription.text = Language.Get(Messages.WIN) + ":";

        // ? RESIZE ALL THE STUFF
        if (this.playerAndDenomText) {
            this.denominationValue.text = Language.Get(Messages.ONE_CREDIT) + " = " + Language.InternationalNumberFormat.format(Client.logic.BalanceManager.GetDenomination());
        }

        this.creditDescriptionTextIfCredit = Language.Get(Messages.CREDIT) + ":";
        this.betDescription.text = Language.Get(Messages.BET) + ":";
        this.winDescription.text = Language.Get(Messages.WIN) + ":";
        this.longestText = [Language.Get(Messages.CREDIT) + ":" + "100.000.000,00 €   ", Language.Get(Messages.BET) + ":" + "100.000.000,00 €   ", Language.Get(Messages.WIN) + ":" + "100.000.000,00 €   ", this.betValue.text + this.betDescription.text, this.winValue.text + this.winDescription.text].sort((a, b) => b.length - a.length)[0];

        let prevText = this.creditsValue.text;
        this.creditsValue.text = this.longestText;
        let fontForCreditTexts;
        if (this.playerAndDenomText)
            fontForCreditTexts = setTextFontScaledToBox(this.creditsValue, width - (4 * horizontalPadding), height / 5);
        else
            fontForCreditTexts = setTextFontScaledToBox(this.creditsValue, width - (4 * horizontalPadding), height / 3.8);

        if (this.playerAndDenomText) {
            if (this.playerName.text.length > this.longestText.length)//Technically it could be longer than all of them, failsafe
                this.playerName.setFontSize(setTextFontScaledToBox(this.playerName, width - (4 * horizontalPadding), height / 5) * 0.85);
            else
                this.playerName.setFontSize(fontForCreditTexts * 0.85);

            this.denominationValue.setFontSize(fontForCreditTexts * 0.85);
        }

        this.creditsValue.setFontSize(fontForCreditTexts);
        this.creditsDescription.setFontSize(fontForCreditTexts);
        this.betValue.setFontSize(fontForCreditTexts);
        this.betDescription.setFontSize(fontForCreditTexts);
        this.winValue.setFontSize(fontForCreditTexts);
        this.winDescription.setFontSize(fontForCreditTexts);
        this.jackpotWin.setFontSize(fontForCreditTexts);

        this.creditsImage.setDisplaySize(this.creditsValue.displayHeight, this.creditsValue.displayHeight);
        this.betImage.setDisplaySize(this.creditsValue.displayHeight, this.creditsValue.displayHeight);
        this.winImage.setDisplaySize(this.creditsValue.displayHeight, this.creditsValue.displayHeight);

        // ? REPOSITION ALL THE STUFF
        if (this.playerAndDenomText) {
            this.playerName.setPosition(width - horizontalPadding, verticalPadding);
            this.denominationValue.setPosition(width - horizontalPadding, this.playerName.y + this.playerName.displayHeight + verticalPadding);
            this.creditsImage.setPosition(width - this.creditsImage.displayWidth - horizontalPadding, this.denominationValue.y + this.denominationValue.displayHeight + verticalPadding);
        } else {
            this.creditsImage.setPosition(width - this.creditsImage.displayWidth - horizontalPadding, verticalPadding);
        }

        this.creditsValue.setPosition(this.creditsImage.x - horizontalPadding, this.creditsImage.y);

        this.betImage.setPosition(width - this.betImage.displayWidth - horizontalPadding, this.creditsImage.y + this.creditsImage.displayHeight + verticalPadding);
        this.betValue.setPosition(this.betImage.x - horizontalPadding, this.betImage.y);

        this.winImage.setPosition(width - this.winImage.displayWidth - horizontalPadding, this.betImage.y + this.betImage.displayHeight + verticalPadding);
        this.winValue.setPosition(this.winImage.x - horizontalPadding, this.winImage.y);

        this.jackpotWin.setPosition(this.winImage.x, this.winImage.y + this.winImage.displayHeight + verticalPadding);

        this.creditsValue.text = "100.000.000,00 €";
        let textPosition = width - (this.creditsValue.displayWidth + this.betImage.displayWidth + horizontalPadding * 2);

        this.creditsDescription.setPosition(textPosition, this.creditsImage.y);
        this.betDescription.setPosition(textPosition, this.betImage.y);
        this.winDescription.setPosition(textPosition, this.winImage.y);

        this.creditsValue.text = prevText;

        // ? DRAW THE LINES
        let shortestX;
        if (this.playerAndDenomText) {
            shortestX = Math.min(this.playerName.x - this.playerName.displayWidth, this.denominationValue.x - this.denominationValue.displayWidth);
        }
        let longestWord = Math.max(this.creditsDescription.displayWidth, this.betDescription.displayWidth, this.winDescription.displayWidth);
        this.graphics.lineStyle(1, 0xffffff, 0.25);
        if (this.playerAndDenomText)
            this.graphics.lineBetween(shortestX, this.playerName.y + this.playerName.displayHeight + verticalPadding / 2, width - horizontalPadding, this.playerName.y + this.playerName.displayHeight + verticalPadding / 2);
        this.graphics.lineBetween(this.creditsDescription.x - longestWord, this.creditsValue.y + this.creditsValue.displayHeight + verticalPadding / 2, width - horizontalPadding, this.creditsValue.y + this.creditsValue.displayHeight + verticalPadding / 2);
        this.graphics.lineBetween(this.creditsDescription.x - longestWord, this.betValue.y + this.betValue.displayHeight + verticalPadding / 2, width - horizontalPadding, this.betValue.y + this.betValue.displayHeight + verticalPadding / 2);
        this.graphics.lineStyle(1, 0xffffff, 1);
        if (this.playerAndDenomText)
            this.graphics.lineBetween(shortestX, this.denominationValue.y + this.denominationValue.displayHeight + verticalPadding / 2, width - horizontalPadding, this.denominationValue.y + this.denominationValue.displayHeight + verticalPadding / 2);

        this.hitArea.setTo(this.betDescription.x + this.betDescription.displayWidth * 1.5, this.creditsDescription.y * 1.5, this.displayWidth, this.displayHeight);
    }
}